export default function SetNeedsConfirmation(state, payload) {
  return {...state, needsConfirmation: payload}
}